import {all, fork} from 'redux-saga/effects';

import { authSaga } from './app/login';

export default function* rootSaga() {
  yield all([
    fork(authSaga)
  ]);
}
